import {
  apiRequest,
  getCronJob,
  getCronJobLog,
  getCronJobLogError,
} from "../../../../../services/adapters/base";

class DataTableRepository {
  fetchAllCronJob = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      getCronJob,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDetailCronJob = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      getCronJobLog,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchCronJobError = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      getCronJobLogError,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
